// Stub for AIFF sample reader — xtracker relies on AudioContext.decodeAudioData.
export function readAIFFsample(arrayBuffer, name, targetSampleRate, bigEndian, onReady){
	if (typeof onReady === "function") onReady(null);
}
